import React from 'react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'

export default function CategoryCardSkeleton() {
    return (
        <Container>
            <IconRect />
            <LabelRect />
        </Container>
    )
}

const shimmer = `
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: wave 2.5s infinite linear;
    @keyframes wave {
        0% { background-position: -200px 0; }
        100% { background-position: calc(200px + 100%) 0; }
    }
`

const Container = styled(Column)`
    width: 120px;
    flex-shrink: 0;
    align-items: center;
    padding: 12px 8px;
    border-radius: 12px;
    gap: 8px;
    background: #f9f9f9;
`;

const IconRect = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 8px;
    ${shimmer}
`;

const LabelRect = styled.div`
    width: 80%;
    height: 12px;
    border-radius: 4px;
    ${shimmer}
`;
